import Tracker from "../prop-trackers/tracker.js";
import DictTracker from "../prop-trackers/dict-tracker.js";
import TrackerGroup from "../prop-trackers/tracker-group.js";

class Zipper extends Tracker {
    constructor() {
        super();

        this._sources = new Map();
        this._sourceIds = new WeakMap();
        this._sourceGroup = new TrackerGroup();

        this._elementTrackers = new Map();
        this._trackerGroup = new TrackerGroup();

        const needsUpdate = () => this.protected_needsUpdate();
        this._sourceGroup.listenNeedsUpdate(needsUpdate);
        this._trackerGroup.listenNeedsUpdate(needsUpdate);
    }

    // sourceTracker must be empty, because existing data won't be accounted for
    setSource(id, sourceTracker) {
        if (this._sourceIds.has(sourceTracker)) {
            throw new Error("Source tracker already added");
        }

        const oldSourceTracker = this._sources.get(id);

        if (oldSourceTracker) {
            this._sourceGroup.remove(oldSourceTracker);
        }

        this._sources.set(id, sourceTracker);
        this._sourceIds.set(sourceTracker, id);
        this._sourceGroup.add(sourceTracker);
    }

    // sourceTracker must be empty, because existing data won't be accounted for
    deleteSource(id) {
        const sourceTracker = this._sources.get(id);

        if (!sourceTracker) {
            return;
        }

        this._sourceGroup.remove(sourceTracker);
        this._sources.delete(id);
    }

    protected_startUpdate() {
        this._sourceGroup.update(({ trackers }) => {
            for (const sourceTracker of trackers) {
                const sourceKey = this._sourceIds.get(sourceTracker);

                sourceTracker.update(({ props }) => {
                    for (const { key, oldExists, newExists, oldValue, newValue } of props.iterateModified()) {
                        let trackerData = this._elementTrackers.get(key);

                        if (newExists) {
                            if (!trackerData) {
                                const tracker = new DictTracker(key);
                                const keys = new Set();
                                trackerData = { tracker, keys };
                                this._elementTrackers.set(key, trackerData);
                                this._trackerGroup.add(tracker);
                            }

                            const { tracker, keys } = trackerData;

                            tracker.setValue(sourceKey, newValue);
                            keys.add(sourceKey);
                        } else {
                            if (trackerData) {
                                const { tracker, keys } = trackerData;

                                tracker.deleteValue(sourceKey);
                                keys.delete(sourceKey);

                                if (keys.size === 0) {
                                    this._trackerGroup.remove(tracker);
                                    this._elementTrackers.delete(key);
                                }
                            }
                        }
                    }
                });
            }
        });

        return this._trackerGroup.startUpdate();
    }

    protected_finishUpdate() {
        this._trackerGroup.finishUpdate();
    }
}

export default Zipper;
